import {IActionHandler} from "./action-handler.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IPerformActionTopicPayload} from "@sparkware/uc-sdk-core";

export abstract class ActionHandlerBase implements IActionHandler {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }


    abstract handle(payload: IPerformActionTopicPayload): Promise<void>;
}